// ============================================================
//  src/components/common/BrandLoader.js
//
//  Full-screen CommandKit loader, shown while the app checks who's
//  signed in. The </> mark draws itself, the tile breathes, and a thin
//  bar slides underneath. On a slow connection it says so after a
//  few seconds instead of spinning silently.
// ============================================================
import React, { useEffect, useState } from 'react';
import './BrandLoader.css';

export default function BrandLoader({ label = 'CommandKit' }) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setSlow(true), 6000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="ckl" role="status" aria-live="polite" aria-label="Loading CommandKit">
      <div className="ckl-stage">
        <span className="ckl-halo" aria-hidden="true" />
        <span className="ckl-tile" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path className="ckl-l" d="m7 8-4 4 4 4" />
            <path className="ckl-r" d="M17 8l4 4-4 4" />
            <path className="ckl-s" d="M14 5l-4 14" />
          </svg>
        </span>
      </div>
      <div className="ckl-word">{label}</div>
      <div className="ckl-bar" aria-hidden="true"><span /></div>
      <p className={`ckl-hint ${slow ? 'is-on' : ''}`}>Still connecting… this can take a moment on a slow network.</p>
    </div>
  );
}
